<template>
  <div
    class="col-span-1"
    :class="[rowSpan, colSpan]"
  >
    <slot />
  </div>
</template>

<script setup>

import { computed } from 'vue';

const props = defineProps({
  rowSpan: {
    type: String,
    default: null,
  },
  colSpan: {
    type: String,
    default: '1',
  },
});

const colSpan = computed(() => {
  const variants = {
    '1': 'col-span-1',
    '2': 'col-span-2',
    '3': 'col-span-3',
    '4': 'col-span-4',
    '5': 'col-span-5',
    '6': 'col-span-6',
    '7': 'col-span-7',
    '8': 'col-span-8',
    '9': 'col-span-9',
    '10': 'col-span-10',
    '11': 'col-span-11',
    '12': 'col-span-12',
  };

  return variants[props.colSpan] || null;
});

const rowSpan = computed(() => {
  const variants = {
    '1': 'row-span-1',
    '2': 'row-span-2',
    '3': 'row-span-3',
    '4': 'row-span-4',
    '5': 'row-span-5',
    '6': 'row-span-6',
    '7': 'row-span-7',
    '8': 'row-span-8',
    '9': 'row-span-9',
    '10': 'row-span-10',
    '11': 'row-span-11',
    '12': 'row-span-12',
  };

  return variants[props.rowSpan] || null;
});

</script>
